import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { InsuranceHubService } from '../services/Insurance-hub.service';
import { NgbAccordionModule, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';

@Component({
  selector: "app-insurance-summary",
  templateUrl: "./insurance-summary.component.html",
  styleUrls: ["./insurance-summary.component.css"],
  standalone: true,
  imports: [ NgbAccordionModule, CommonModule ]
})
export class InsuranceSummaryComponent implements OnInit {
  @ViewChild('callbackSuccessModel', { static: false }) callbackSuccessModel: ElementRef;
  UserPolicyDetails;
  isAvailablePolicy: boolean=false;
  modalOptions: NgbModalOptions;
  eRef: ElementRef;
  constructor(private insuranceHubService: InsuranceHubService, private modalService: NgbModal,
    private elementRef: ElementRef,private router: Router) { }
  ngOnInit(): void {
    this.GetPolicyDetails();
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      keyboard: false
    };
    this.eRef = this.elementRef; 
     
    
  }

  GetPolicyDetails() {
    this.insuranceHubService.GetUserPolicyListWithDetails().subscribe({
        next: (data: any) => {
      this.UserPolicyDetails = data;
      if(this.UserPolicyDetails?.isDataAvailable==false)
      {
        this.isAvailablePolicy = false;
        this.router.navigate(['/portal/dashboard']);
      }
    }});

    if (this.UserPolicyDetails?.creditLifePolicyResponse == null
      || this.UserPolicyDetails?.lifeCoverPolicyResponse == null
      || this.UserPolicyDetails?.legalCoverPolicyResponse == null
      || this.UserPolicyDetails?.funeralCoverPolicyResponse == null
    ) {
      this.isAvailablePolicy = true;
    }
    else {
      this.isAvailablePolicy = false;
    }
  }

  RequestCallBackEmail(id: number, policyDetails: any) {
    var payload = {
      emailTemplateType: id,
      insuranceHubPolicyResponse: policyDetails
    }

    this.insuranceHubService.RequestCallBackEmail(payload).subscribe({
        next: (data: any) => {

    }});
  }
  CallBackLms(campaignSource: string) {

    var payload = {
      campaignSource: campaignSource
    }
    this.insuranceHubService.RequestCallBackFSLms(payload).subscribe({
        next: (data: any) => {
      this.modalService.dismissAll();
      this.modalService.open(this.callbackSuccessModel, this.modalOptions);
    }, error: (err: HttpErrorResponse) => {
      this.modalService.dismissAll();
      this.modalService.open(this.callbackSuccessModel, this.modalOptions);
    }});

  }

}
